module.exports = __webpack_public_path__ + "img/about3.41e466d5.png";